import { Drill, Cable, Zap, Network, Wrench, Target } from "lucide-react"
import { Card } from "@/components/ui/card"

const services = [
  {
    icon: Drill,
    title: "HDD Services",
    description: "Expert horizontal directional drilling for minimal surface disruption",
  },
  {
    icon: Cable,
    title: "Fiber Optic Installation",
    description: "Professional fiber pulling, splicing, and network deployment",
  },
  {
    icon: Zap,
    title: "Micro Trenching",
    description: "Efficient shallow trenching solutions for rapid deployment",
  },
  {
    icon: Network,
    title: "Network Infrastructure",
    description: "Complete infrastructure planning and implementation",
  },
  {
    icon: Wrench,
    title: "Maintenance",
    description: "Ongoing support and maintenance for your infrastructure",
  },
  {
    icon: Target,
    title: "Consulting",
    description: "Expert guidance for your infrastructure projects",
  },
]

export function ServicesSectionModern() {
  return (
    <section className="py-24 bg-muted/30">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center mb-16">
          <h2 className="text-4xl font-bold tracking-tight mb-4">
            Our <span className="text-primary">Services</span>
          </h2>
          <p className="text-lg text-muted-foreground">
            Comprehensive infrastructure solutions tailored to your needs
          </p>
        </div>
        
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {services.map((service, index) => {
            const Icon = service.icon
            return (
              <Card key={index} className="group p-6 hover:shadow-lg transition-all duration-300 hover:scale-105 cursor-pointer border-2 hover:border-primary/50">
                <div className="flex flex-col gap-4">
                  <div className="w-14 h-14 rounded-2xl bg-primary/10 flex items-center justify-center group-hover:bg-primary group-hover:scale-110 transition-all duration-300">
                    <Icon className="h-7 w-7 text-primary group-hover:text-primary-foreground" />
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold mb-2">{service.title}</h3>
                    <p className="text-muted-foreground">{service.description}</p>
                  </div>
                </div>
              </Card>
            )
          })}
        </div>
      </div>
    </section>
  )
}
